import actions from './manageUserGroups.actions'
import mutations from './manageUserGroups.mutations'

const state = {
  userGroupsList: [],
  userGroupDetails: {},
  trackingGroups: [],
  benefitGroups: [],
  parentGroups: [],
  groupSummary: false
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
